'use client';

import { freddyTheme, Tag, TagProps } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

import { openInternalPopup } from '../../utils/internalPopup';

export default function CurrentStoreStockIconTag({
  url,
  index,
  totalIndices,
  stockCount,
  message,
  intent
}: {
  url: string;
  index: number;
  totalIndices: number;
  stockCount: number;
  message: string;
  intent: TagProps['intent'];
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <Tag
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'stock_information',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'current_store_stock_information',
            attribute: 'current_store_stock_information'
          })
        );
        openInternalPopup(url);
      }}
      variant='subtle'
      intent={stockCount === 0 ? undefined : intent}
      sx={{
        cursor: 'pointer',

        ...(stockCount === 0 && {
          color: freddyTheme.color.font.interactiveSubtle,
          backgroundColor: freddyTheme.color.background.tertiary
        })
      }}
    >
      {message}
    </Tag>
  );
}
